export default () => {
    let lastScrollTop = 0;
    if ( document.documentElement.scrollTop > 0 ) {
        document.body.classList.add("scrollin");
    }
    window.addEventListener("scroll", function(){
        let st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
        if (st > lastScrollTop){
            document.body.classList.remove("up");
            document.body.classList.add("down");
        } else {
            document.body.classList.remove("down");
            document.body.classList.add("up");
        }
        lastScrollTop = st <= 0 ? 0 : st;
        if( lastScrollTop !== 0) {
            document.body.classList.add("scrollin");
        } else {
            document.body.classList.remove("scrollin");
            document.body.classList.remove("up");
            document.body.classList.remove("down");
        }
    }, false);
}